export const User = (json: IUser): IUserModel => {
	const fromJSON = (user: IUser): IUserModel => {
		const { first_name, last_name, phone_number, uuid, ...rest } = user
		return {
			id: uuid,
			uuid,
			firstName: first_name,
			lastName: last_name,
			phoneNumber: phone_number,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const userToJSON = (obj: Partial<IUserModel>): Partial<IUser> => {
	const { firstName, lastName, phoneNumber, ...rest } = obj
	return {
		first_name: firstName,
		last_name: lastName,
		phone_number: phoneNumber,
		...rest,
	}
}
